<script>
    import Fila from "./Fila.svelte";

    export let marcajes;
</script>

<style>
    th:not(:nth-child(3)):not(:nth-child(2)) {
        width: 1%;
    }

    :global(.marcajes .hora) {
        justify-content: flex-start !important;
    }

    :global(.marcajes .separador) {
        margin: 0 .5em;
    }
</style>

<table class="marcajes">
    <thead>
    <th>Día</th>
    <th>Trabajador/a</th>
    <th>Marcajes</th>
    <th>Origen</th>
    <th>Prev.</th>
    <th>Trab.</th>
    <th>Dif.</th>
    <th>&nbsp;</th>
    </thead>
    <tbody>
    {#each marcajes as marcaje}
        <Fila {marcaje} />
    {/each}
    </tbody>
</table>